module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Cart3-6fa5fa3ed73ac5f649ff014e6ef5eed8.svg";